import Vue from 'vue'
import Vuex from 'vuex'

import mutations from './mutations'
import getters from './getters'
import actions from './actions'

Vue.use(Vuex)
const store = {
  namespaced: true,
  state: () => ({
    pendingItems: [],
    checkedItems: [],
    /**
     * Paciente da última carga de pendências. A seleção (`checkedItems`) é
     * global e sobrevive à troca de prontuário, então é preciso saber de quem
     * ela é: ao carregar as pendências de OUTRO paciente, a seleção antiga é
     * zerada (bug 86akkda27 — "Criar nova guia" vinculava a pendência de
     * outra pessoa). Paginar o mesmo paciente preserva a seleção.
     */
    patientId: null,
    loading: false,
    page: 1,
    count: 0,
    limit: 0
  }),
  mutations,
  getters,
  actions
}

export default store
